import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../services/api";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const init = async () => {
      const token = localStorage.getItem("md_token");
      if (token) {
        try {
          const { data } = await api.get("/auth/me");
          setUser(data);
        } catch {
          localStorage.removeItem("md_token");
        }
      }
      setAuthReady(true);
    };
    init();
  }, []);

  const register = async (name, email, password, newsletter = false) => {
    const { data } = await api.post("/auth/register", { name, email, password, newsletter });
    localStorage.setItem("md_token", data.token);
    setUser(data.user);
    return data;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("md_token", data.token);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("md_token");
    setUser(null);
  };

  const updateProfile = async (payload) => {
    const { data } = await api.put("/auth/profile", payload);
    setUser(data);
    return data;
  };

  const refreshUser = async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); return data; } catch { return null; }
  };

  return (
    <AuthContext.Provider value={{ user, authReady, register, login, logout, updateProfile, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};
